import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/userSlice';
import authReducer from './reducers/authSlice';
import { oqulyqtarApi } from '../api/api';
import { editorApi } from '../api/editorApi/api';
import notificationReducer from './reducers/notificationSlice';
import filterReducer from './reducers/filterSlice';
import spinnerReducer from './reducers/spinnerSlice';

const rootReducer = combineReducers({
    [oqulyqtarApi.reducerPath]: oqulyqtarApi.reducer,
    [editorApi.reducerPath]: editorApi.reducer,
    user: userReducer,
    auth: authReducer,
    notification: notificationReducer,
    filter: filterReducer,
    spinner: spinnerReducer
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(oqulyqtarApi.middleware).concat(editorApi.middleware)
});
